import { ConditionsAreaWrapper } from 'components/SearchSideBar/ConditionsAreaWrapper';
import { JobOfferKindType } from 'components/SearchSideBar/Details/types';
import { SearchDetailCondition } from 'components/SearchSideBar/SearchDetailCondition';
import { SidebarSection } from 'components/SearchSideBar/SidebarSection';
import { UpdateJobCountType } from 'components/SearchSideBar/types';
import { FC, memo } from 'react';

/**
 * Detailsコンポーネントのプロパティを定義するインターフェース
 */
interface Props {
  /** 応募方法の種類 */
  jobOfferKind: JobOfferKindType;
  /** 求人数の更新関数 */
  updateJobCount: UpdateJobCountType;
  /** オーバーレイの表示状態を変更する関数 */
  onChangeIsShowOverlay: () => void;
}

/**
 * Detailsコンポーネント
 *
 * @param {Props} props - コンポーネントのプロパティ
 * @returns {JSX.Element} JSX要素
 */
export const Details: FC<Props> = memo(
  ({ jobOfferKind, updateJobCount, onChangeIsShowOverlay }) => {
    return (
      <SidebarSection title="詳細条件">
        <ConditionsAreaWrapper>
          <SearchDetailCondition
            title="応募方法"
            list={jobOfferKind.jobOfferKindList}
            onChange={(event) => {
              updateJobCount({
                jobOfferKind:
                  jobOfferKind.updateIsCheckedJobOfferKindList(event),
              });
              onChangeIsShowOverlay();
            }}
          />
        </ConditionsAreaWrapper>
      </SidebarSection>
    );
  }
);

Details.displayName = 'Details';
